module.exports = __webpack_public_path__ + "static/slide12-520fd6637afb643a4cc9a22a82c019f9.jpg";